import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import InventoryManagementService from 'services/api/InventoryManagement.service';

// -------------------------------------------------------------------------

interface IInventoryManagementState {
    loading: boolean;
    error: IErrorModel | undefined;
    inventoryManagement: []
}

const initialState: IInventoryManagementState = {
    loading: false,
    error: {} as IErrorModel,
    inventoryManagement: [],
};

// -------------------------------------------------------------------------

export const getInventoryManagementThunk = createAsyncThunk<
    IPaginatedResponse,
    { size: number; page: number; type: string; startDate: string; endDate: string },
    { rejectValue: IErrorModel }
>(`/inventoryManagement/getInventoryManagement`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await InventoryManagementService.getInventoryManagement(params);
        return response.data.transactions
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch inventory management data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------

const inventoryManagementSlice = createSlice({
    name: `inventoryManagement`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Inventory Management
        builder.addCase(getInventoryManagementThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getInventoryManagementThunk.fulfilled, (state :any, action :any) => {
            state.loading = false;
            state.inventoryManagement = action.payload;
        });
        builder.addCase(getInventoryManagementThunk.rejected, (state, action) => {
            state.loading = false;
            state.inventoryManagement = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default inventoryManagementSlice;
export const inventoryManagementReducer = inventoryManagementSlice.reducer;

